
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/car-plate",
      function () {
        return require("private-next-pages/car-plate.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/car-plate"])
      });
    }
  